/**
 * A component that embeds the dashboard template for a dashboard onto the page
 * and provides context between the dashboard and the embedded template.
 */
export const DashboardContentComponent = {
    bindings: {
        dashboard: "<"
    },
    // Since the dashboard template isn't a component, it can't be passed a reference
    // to the dashboard through its bindings. Components in the template can
    // access this parent component using require syntax as a workaround.
    template: `<div apex-partial-src="{{ $ctrl.dashboard.DashboardTemplate }}"></div>`,
    controller: class DashboardContent {
        $onInit() {
            this.dashboard.loaded = false
        }

        /**
         * Activate the dashboard by initializing its data properties.
         * @param {any} dashboardData The data used to activate the dashboard, which can be
         *   used to control visibility, pass data, set a count, or define actions.
         */
        activateDashboard({ visible, data, count, actions }) {
            this.dashboard.visible = visible
            this.dashboard.data = data
            this.dashboard.count = count
            // Action use will be defined by the list item, but typically
            // this will be an object revealing methods to the dashboard.
            this.dashboard.actions = actions
            this.dashboard.loaded = true
        }
    }
}
